import { createContext, useContext, useState } from "react";

type RefreshEntry = { id: number; address: string | null; addedAt: number };

type EstimateRefreshContextValue = {
  activeRefreshes: RefreshEntry[];
  addRefresh: (entry: RefreshEntry) => void;
  removeRefresh: (id: number) => void;
};

const EstimateRefreshContext = createContext<EstimateRefreshContextValue>({
  activeRefreshes: [],
  addRefresh: () => {},
  removeRefresh: () => {},
});

export function EstimateRefreshProvider({ children }: { children: React.ReactNode }) {
  const [activeRefreshes, setActiveRefreshes] = useState<RefreshEntry[]>([]);

  const addRefresh = (entry: RefreshEntry) =>
    setActiveRefreshes(prev =>
      prev.some(r => r.id === entry.id) ? prev : [...prev, entry]
    );

  const removeRefresh = (id: number) =>
    setActiveRefreshes(prev => prev.filter(r => r.id !== id));

  return (
    <EstimateRefreshContext.Provider value={{ activeRefreshes, addRefresh, removeRefresh }}>
      {children}
    </EstimateRefreshContext.Provider>
  );
}

export const useEstimateRefresh = () => useContext(EstimateRefreshContext);
